import React, {Component} from 'react'
import {Query} from 'react-apollo'
import {toast} from 'react-toastify'
import {
  Typography,
  Button,
  Card,
  TextField,
  Select,
  MenuItem,
  SnackbarContent,
} from '@material-ui/core'
import {MEMBERS} from '../../../../graphql/query'
import {inviteUser} from '../../../../functions/project'
import EditMemberComponent from './components/EditMemberComponent'

class ProjectMemberPage extends Component {
  state = {
    saving: false,
    email: '',
    role: 'admin',
    warning: false,
    hide: false,
  }

  handleEmailChange = e => {
    this.setState({email: e.target.value})
  }

  handleRoleChange = e => {
    this.setState({role: e.target.value})
  }

  handleAddMember = async callback => {
    try {
      this.setState({saving: true})
      await inviteUser(this.props.project.id, this.state.email, this.state.role)
      this.setState({warning: false, email: '', role: 'admin'})
      toast.success('Member is added', {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
      callback()
    } catch (e) {
      this.setState({warning: true})
    } finally {
      this.setState({saving: false})
    }
  }

  render() {
    if (this.state.hide) {
      return <div />
    }
    return (
      <div style={{display: 'flex', ...this.props.style}}>
        <Query query={MEMBERS} variables={{projectId: this.props.project.id}}>
          {({loading, error, data, refetch}) => (
            <Card
              style={{
                padding: '20px',
                marginBottom: '20px',
                display: 'flex',
                justifyContent: 'space-evenly',
                alignItems: 'baseline',
                width: '100%',
              }}
            >
              <EditMemberComponent project={this.props.project} />

              <div>
                {this.state.warning && (
                  <SnackbarContent
                    style={{margin: '20px 0'}}
                    variant="warning"
                    aria-describedby="client-snackbar"
                    message="Cannot find user email, Please make sure that user already register in the systems"
                  />
                )}
                <Typography variant="title">Add Member to Project</Typography>
                <div style={{display: 'flex', alignItems: 'baseline'}}>
                  <TextField
                    style={{width: '200px'}}
                    label="Email"
                    value={this.state.email}
                    onChange={this.handleEmailChange}
                  />
                  <Select
                    value={this.state.role}
                    onChange={this.handleRoleChange}
                  >
                    <MenuItem value="owner">Owner</MenuItem>
                    <MenuItem value="admin">Admin</MenuItem>
                  </Select>
                  <Button
                    disabled={this.state.saving}
                    variant="contained"
                    style={{backgroundColor: '#663EE8', color: '#F9FDFF'}}
                    onClick={() => this.handleAddMember(refetch)}
                  >
                    Add to Project
                  </Button>
                </div>
              </div>
            </Card>
          )}
        </Query>
      </div>
    )
  }
}

export default ProjectMemberPage



// WEBPACK FOOTER //
// ./src/main/content/project/settings/ProjectMemberPage.js